import { render } from "./FpTab.vue?vue&type=template&id=59c09665&lang=pug"
import script from "./FpTab.vue?vue&type=script&lang=js"
export * from "./FpTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__